import { render, staticRenderFns } from "./CompetenceSidebar.vue?vue&type=template&id=2a88f7b8&scoped=true"
import script from "./CompetenceSidebar.vue?vue&type=script&lang=js"
export * from "./CompetenceSidebar.vue?vue&type=script&lang=js"
import style0 from "./CompetenceSidebar.vue?vue&type=style&index=0&id=2a88f7b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a88f7b8",
  null
  
)

export default component.exports